export function normalizeDataToPixel(
  dataPoint: number,
  rangeStart: number,
  rangeEnd: number,
  pixelDimension: number,
) {
  return ((dataPoint - rangeStart) / (rangeEnd - rangeStart)) * pixelDimension;
}
